import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        classifiers: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '='
    },
    template: `
        <div class="form">
            <modals-courses-occurrence-employee-customized-filter
                classifiers="vm.classifiers"
                list="vm.list"
                occurrence="vm.occurrence"
                versions="vm.versions"
            />
            <modals-courses-occurrence-employee-table
                enable-all="true"
                list="vm.list"
                user-ids="vm.userIds"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
                custom-options="[1000,2500]"
            />
        </div>
    `
})
export default class {
    constructor (DATATABLES, MomentService, OccurrenceResource, ListFactory, CourseVersionResource) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.CourseVersionResource = CourseVersionResource;

        this.list = ListFactory.createWithPagination(OccurrenceResource.getUsers.bind(OccurrenceResource));
        this.list.pagination.perPage = 25;
    }

    $onInit () {
        this.CourseVersionResource.query({
            courseId: this.occurrence.courseId,
            includeArchived: true,
            pageSize: 0
        }).$promise.then(versions => {
            this.versions = versions;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/customized/index.js